import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { SpringScrollbars } from '../';
import BEM from '../../bem';
import { mobxInjectSelect } from '../../utils';
import CallingPreferencesSettings from './CallingPreferencesSettings';
import {
  About,
  AccountSettings,
  BangFilterSettings,
  DesktopAppSettings,
  DownloadApp,
  ExpertSettings,
  ProfileMenu,
  ProfileHeader,
  ProfileInfo,
  NewProfileStatus,
  NewProviderStatus,
} from './';
import propTypes from 'common/propTypes';

const classes = BEM.with('Profile');

class Profile extends Component {
  static propTypes = {
    expertMode: PropTypes.bool.isRequired,
    getAutoForwardEntityDisplayNameByOrg: PropTypes.func,
    isBangFilterSettingsEnabled: PropTypes.bool,
    isCallingAvailable: PropTypes.func.isRequired,
    setScrollbars: PropTypes.func.isRequired,
    setScrollbarsElement: PropTypes.func.isRequired,
    currentOrganization: propTypes.organization,
  };

  render() {
    const {
      currentUser,
      expertMode,
      getAutoForwardEntityDisplayNameByOrg,
      isBangFilterSettingsEnabled,
      isCallingAvailable,
      stopCurrentAction,
      currentOrganization,
    } = this.props;

    const autoForwardEntitiesDisplayName = (organization) => {
      const currentAutoForwardDisplayText = currentOrganization?.dndAutoForwardEntities
        ? getAutoForwardEntityDisplayNameByOrg(organization)
        : organization?.autoForwardReceiver?.displayName;
      return currentAutoForwardDisplayText;
    };

    return (
      <div
        className={classes()}
        tabIndex={-1}
        onKeyDown={(e) => e.key === 'Escape' && stopCurrentAction()}
      >
        <ProfileHeader />
        <div className={classes('content')}>
          <ProfileMenu />
          <div className={classes('scroll')}>
            <SpringScrollbars ref={this._setScrollbars} shouldScrollOverflow={true}>
              <div className={classes('body')}>
                <div className={classes('items')} ref={this._setScrollbarsElement}>
                  <ProfileInfo />
                  <NewProviderStatus />
                  <NewProfileStatus
                    autoForwardEntitiesDisplayName={autoForwardEntitiesDisplayName}
                    dndText={currentUser.dndText}
                    dnd={currentUser.dnd}
                    dndExpireAt={currentUser.dndExpireAt}
                    inRole={currentUser.roles?.length > 0}
                  />
                  <AccountSettings />
                  <DesktopAppSettings />
                  {isBangFilterSettingsEnabled && <BangFilterSettings />}
                  {isCallingAvailable && <CallingPreferencesSettings />}
                  {expertMode && <ExpertSettings />}
                  <About />
                  <DownloadApp />
                </div>
              </div>
            </SpringScrollbars>
          </div>
        </div>
      </div>
    );
  }

  _setScrollbars = (ref) => {
    this.props.setScrollbars(ref);
  };

  _setScrollbarsElement = (ref) => {
    const { setScrollbarsElement } = this.props;
    setScrollbarsElement(ref, 'ProfileInfo');
  };
}

export default mobxInjectSelect({
  callStore: ['isCallingAvailable'],
  localStore: ['expertMode'],
  messengerStore: ['isBangFilterSettingsEnabled', 'stopCurrentAction', 'currentOrganization'],
  profileStore: ['setScrollbars', 'setScrollbarsElement'],
  sessionStore: ['currentUser'],
  userStore: ['getAutoForwardEntityDisplayNameByOrg'],
})(Profile);
